import { PropertyTileProps } from '../../../app-kit/components/PropertyTile/PropertyTile';
import { ShowMoreTilesData } from '../../../analytics/event-tracking/trackShowMoreTiles';
import { WebLink, WebLinkProps } from '../../../app-kit/components/WebLink/WebLink';
import styled from 'styled-components';
import { spacingHelper, typographyHelper } from '@property.com.au/ui-kit';
import { FunctionComponent } from 'react';
import { ContentBrick } from '../../../app-kit/components/ContentBrick/ContentBrick';
import { PropertyCarousel } from '../../../app-kit/components/PropertyCarousel/PropertyCarousel';
import { StyledProptrackLogoBrickSource } from '../../../components/ProptrackLogoBrickSource/ProptrackLogoBrickSource';

interface SuburbPagePropertyCollectionBrickProps {
  title: string;
  subtitle: string;
  properties: PropertyTileProps[];
  tracking?: { showMoreProperties: ShowMoreTilesData } | null;
  searchPageWebLink?: WebLinkProps | null;
  showPropTrackLogo?: boolean;
}

const SearchPageWebLink = styled(WebLink)`
  text-align: center;
  width: fit-content;
  float: none;
  ${typographyHelper('overline')};
  display: block;
  margin: ${spacingHelper('extraSmall auto 0')};
`;

export const SuburbPagePropertyCollectionBrick: FunctionComponent<
  SuburbPagePropertyCollectionBrickProps
> = ({ title, subtitle, properties, tracking, searchPageWebLink, showPropTrackLogo }) => {
  return (
    <ContentBrick title={title} subtitle={subtitle}>
      <PropertyCarousel
        properties={properties}
        tracking={tracking?.showMoreProperties}
        preloadCount={3}
      />
      {searchPageWebLink && (
        <SearchPageWebLink
          title={searchPageWebLink.title}
          url={searchPageWebLink.url}
          isExternal={searchPageWebLink.isExternal}
          variant={searchPageWebLink.variant}
          tracking={searchPageWebLink.tracking}
        />
      )}
      {showPropTrackLogo && <StyledProptrackLogoBrickSource />}
    </ContentBrick>
  );
};
